import "./IconDownloadButton.scss";
import { ReactComponent as DownloadButton } from "./svg/icon-download-button.svg";

type Props = {
  id?: string;
  width?: string;
  height?: string;
};

export const IconDownloadButton = ({ id = "", width, height }: Props) => {
  return (
    <span id={id} className="icon-download-button" style={{ width, height }}>
      <DownloadButton style={{ width, height }} />
    </span>
  );
};
